import script from "./ProjectStatusReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectStatusReport.vue?vue&type=script&setup=true&lang=js"

import "./ProjectStatusReport.vue?vue&type=style&index=0&id=ea5384a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea5384a4"]])

export default __exports__